module.exports = __webpack_public_path__ + "static/media/daterange.36aa969b.png";